import React, { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import WebsiteSidebar from "../components/Website/WebsiteSidebar";
import MyOrders from "../pages/Website/UserDashboard/MyOrders";
import WishList from "../pages/Website/UserDashboard/WishList";
import LoyaltyPoints from "../pages/Website/UserDashboard/LoyaltyPoints";
import ProfilePage from "../pages/Website/UserDashboard/ProfilePage";
import SubscriptionDetails from "../pages/Website/UserDashboard/SubscriptionDetails";
import MyAddresses from "../pages/Website/UserDashboard/MyAddresses";
import AddAddressForm from "../pages/Website/UserDashboard/AddAddressForm";
import { FaChevronLeft } from "react-icons/fa6";
import { IoMenu } from "react-icons/io5";

function UserLayout({ logo }) {
  const customer = localStorage.getItem("rms-customer");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!customer) {
      navigate("/");
    }
  }, [customer, navigate]);
  return (
    <main className="max-w-7xl w-[90%] flex gap-4 mx-auto mb-16 mt-4 relative">
      <button
        className="fixed top-[6rem] left-0 p-3 bg-w-btn text-w-btn-text rounded-tr-lg rounded-br-lg block lg:hidden"
        onClick={() => setSidebarOpen(!sidebarOpen)}
      >
        <IoMenu className="text-2xl" />
      </button>
      <div
        className={`fixed top-0 left-0 bottom-0 overflow-y-auto z-[99] lg:z-auto lg:static w-[270px] lg:w-[300px] overflow-x-visible transition-all ${
          !sidebarOpen ? "-translate-x-full lg:translate-x-0" : ""
        }`}
      >
        <button
          className={`absolute top-10 ${
            sidebarOpen ? "right-0" : "-right-6"
          } bg-w-btn text-w-btn-text border p-4 rounded-full z-[9999] block lg:hidden`}
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          <FaChevronLeft className="text-4xl" />
        </button>
        {sidebarOpen && (
          <div
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="w-screen h-screen bg-black bg-opacity-25 backdrop-blur-xl fixed top-0 left-0"
          ></div>
        )}
        <WebsiteSidebar />
      </div>
      <div className="w-full">
        <Routes>
          <Route path="/" element={<MyOrders logo={logo} />} />
          <Route path="/myAddress" element={<MyAddresses />} />
          <Route
            path="/myAddress/addEditAddress"
            element={<AddAddressForm />}
          />
          <Route
            path="/myAddress/addEditAddress/:id"
            element={<AddAddressForm />}
          />
          <Route path="/wishlist" element={<WishList />} />
          <Route path="/loyalty" element={<LoyaltyPoints />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route
            path="/subscription-details"
            element={<SubscriptionDetails />}
          />
        </Routes>
      </div>
    </main>
  );
}

export default UserLayout;
